import { faEdit } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Field } from "formik";
import React from "react";
import { get } from "lodash";
import {
  AddToolTip,
  FieldInputDollarBox,
  WithDrawalCard,
} from "../../../components";
import { OPTIONS_DATA_MAPPER } from "../../../utils";
import {
  getAddressDisplay,
  getBankDisplay,
  getCodeOptions,
  getFullName,
  getValues,
} from "./DistributionConstantsAndFunctions";

const columns = [
  {
    label: "Recipient",
    width: "13.6%",
    columnName: "recipient",
  },
  {
    label: "Payment Details",
    width: "20.6%",
    columnName: "paymentDetails",
  },
  {
    label: "1099 Code",
    width: "16.6%",
    columnName: "code",
  },
  {
    label: "Tax",
    width: "10%",
    columnName: "tax",
  },
  {
    label: "Fee",
    width: "10%",
    columnName: "fee",
  },
  {
    label: "Penalty",
    width: "10.5%",
    columnName: "penalty",
  },
  {
    label: "Amount",
    width: "14.5%",
    columnName: "recipient",
  },
  {
    label: "",
    width: "5%",
    columnName: "editButton",
  },
];

function AddedRecipientCard(props) {
  const {
    fields,
    values,
    handleChange,
    setSelectedIndex,
    setWithdrawalSlider,
    withdrawalRequestData,
    employeeData,
    ...rest
  } = props;

  const beneficiaryDistributionMode = 5;
  const selfDistributionMode = 1;
  const distributionModes = OPTIONS_DATA_MAPPER.DISTRIBUTION_MODES;
  const codeOptionsRollOver = OPTIONS_DATA_MAPPER.CODE_OPTIONS_ROLLOVER;
  const codeOptionsCash = OPTIONS_DATA_MAPPER.CODE_OPTIONS_CASH;
  if (get(values, "withdrawalTransactions", []).length === 0) return <></>;
  return (
    <div>
      <div
        style={{
          display: "flex",
          // justifyContent: "space-around",
          alignItems: "center",
          // gridGap: "32px",
          // gap: "32px",
          margin: "0px 20px",
        }}
      >
        {columns.map((_, ind) => {
          return (
            <div
              style={{
                width: _.width,
                color: "#919191",
                fontWeight: "600",
                fontSize: "16px",
                whiteSpace: "nowrap",
              }}
            >
              {_.label}
            </div>
          );
        })}
      </div>
      {console.log("aaa", get(values, "withdrawalTransactions", []))}
      <>
        {get(values, "withdrawalTransactions", []).map((transaction_, ind) => {
          const bankAddressDisplay =
            transaction_.paymentMethod === 2
              ? getBankDisplay(transaction_.bankInformation)
              : getAddressDisplay(transaction_.address);
          const isBeneficiary =
            transaction_.distributionMode === beneficiaryDistributionMode;
          const beneficiary = withdrawalRequestData?.beneficiaries?.find(
            (x, ind) => x.id === transaction_.beneficiaryId
          );
          const recipientName = isBeneficiary
            ? beneficiary?.name
            : getFullName(employeeData);
          return (
            <>
              <WithDrawalCard cssStyle={{ marginBottom: "15px" }}>
                <div
                  style={{
                    width: columns[0].width,
                  }}
                >
                  {recipientName.length > 10 ? (
                    <div>
                      <AddToolTip name={recipientName}>
                        {(recipientName || "").slice(0, 10)}...
                      </AddToolTip>
                    </div>
                  ) : (
                    <div className="sourceHierarchy_Card_Headerfont">
                      {recipientName}
                    </div>
                  )}

                  {distributionModes[transaction_?.distributionMode].length >
                  10 ? (
                    <div>
                      <AddToolTip
                        name={distributionModes[transaction_?.distributionMode]}
                      >
                        {(
                          distributionModes[transaction_?.distributionMode] ||
                          ""
                        ).slice(0, 10)}
                        ...
                      </AddToolTip>
                    </div>
                  ) : (
                    <div className="sourceHierarchy_Card_Headerfont">
                      {distributionModes[transaction_?.distributionMode]}
                    </div>
                  )}
                </div>

                <div
                  style={{
                    width: columns[1].width,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  <div>
                    {transaction_.paymentMethod === 2 ? "EFT" : "Check"}
                  </div>
                  <div>
                    {bankAddressDisplay.length > 10 ? (
                      <div>
                        <AddToolTip name={bankAddressDisplay}>
                          {(bankAddressDisplay || "").slice(0, 10)}...
                        </AddToolTip>
                      </div>
                    ) : (
                      <div className="sourceHierarchy_Card_Headerfont">
                        {bankAddressDisplay}
                      </div>
                    )}
                  </div>
                </div>

                <div
                  style={{
                    width: columns[2].width,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {transaction_.code &&
                  getCodeOptions(transaction_)[transaction_.code].length >
                    10 ? (
                    <AddToolTip
                      name={getCodeOptions(transaction_)[transaction_.code]}
                    >
                      {getCodeOptions(transaction_)[transaction_.code]?.slice(
                        0,
                        10
                      )}
                      ...
                    </AddToolTip>
                  ) : (
                    <div className="w-75 d-flex justify-content-center">-</div>
                  )}
                </div>

                <div style={{ width: "10%" }}>
                  {getValues(transaction_[fields.stateTax]) +
                    getValues(transaction_[fields.federalTax])}{" "}
                  %
                </div>

                <div style={{ width: columns[4].width }}>
                  ${" "}
                  {getValues(transaction_[fields.checkFee]) +
                    getValues(transaction_[fields.eftFee]) +
                    getValues(transaction_[fields.rollOverFee])}
                </div>

                <div style={{ width: columns[5].width }}>
                  {get(transaction_, fields.waiveOffLimitApplicable, false)
                    ? `${getValues(transaction_[fields.waiveOffLimit])} %`
                    : `${getValues(
                        transaction_[fields.earlyWithdrawalPenalty]
                      )} %`}{" "}
                </div>

                <div style={{ width: columns[6].width }}>
                  <Field
                    size="xs"
                    isRequired
                    //className="w-200 marg-left-20"
                    name={`withdrawalTransactions.${ind}.${fields.requestedAmount}`}
                    type="text"
                    autoComplete="off"
                    max={50000.0}
                    min={0}
                    value={get(transaction_, fields.requestedAmount)}
                    disabled={true}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    component={FieldInputDollarBox}
                  />
                </div>
                <div
                  style={{ width: columns[7].width }}
                  className="ft-14 fw-400 light-blue cursor-pointer"
                >
                  {values[fields.modeOfPayment] === 1 && (
                    <FontAwesomeIcon
                      icon={faEdit}
                      className="ft-14 fw-300 ml-2 cursor-pointer"
                      onClick={() => {
                        setSelectedIndex(ind);
                        setWithdrawalSlider(true);
                      }}
                    />
                  )}
                </div>
              </WithDrawalCard>
            </>
          );
        })}
      </>
    </div>
  );
}

export default AddedRecipientCard;
